// extracted by mini-css-extract-plugin
export default {"form":"_d","inline":"ae","inputWrapper":"be","input":"ce","withoutLabel":"de","error":"ee","label":"fe"};